export const facilities = [
  {
    id: "blaby-leicester",
    title: "UK - Blaby Facility",
    desc: "A specialized assembly and integration hub focused on high-specification industrial enclosures and modular power solution configuration.",
    location: "W3 Winchester Avenue, Blaby, Leicester, LE8 4GZ, UK",
    totalArea: "6,210 sq.ft",
    productionCapacity: "Up to 900 tons annually",
    highlights: [
      "Dedicated floor space for modular enclosure fit-outs and wiring",
      "Specialized assembly bays for custom industrial equipment integration",
      "Robust electrical infrastructure supporting testing of finished enclosure units",
      "System-level testing capabilities for complex power and control assemblies",
    ],
    facilityImg: [
      "https://media.arcengltd.com/facility-images/Blaby_Facility_01.webp",
      "https://media.arcengltd.com/facility-images/Blaby_Facility_09.webp",
      "https://media.arcengltd.com/facility-images/Blaby_Facility_07.webp",
      "https://media.arcengltd.com/facility-images/Blaby_Facility_08.webp",
    ],
    capabilityImg: [
      {
        img: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp",
        title: "Enclosure Integration & Wiring",
        desc: "Equipped for the precision installation of control systems, switchgear, and internal components within industrial enclosures.",
      },
      {
        img: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp",
        title: "System Testing & Final QC",
        desc: "Designated area for rigorous electrical and functional testing of finished units prior to deployment.",
      },
    ],
  },
  {
    id: "hamriyah",
    title: "UAE - Hamriyah Facility",
    desc: "State-of-the-art manufacturing facility equipped with advanced machinery for precision engineering and metal fabrication.",
    location: "Hamriyah Free Zone, Sharjah",
    totalArea: "120,000 sq.ft",
    productionCapacity: "Up to 1,800 tons annually",
    highlights: [
      "Advanced CNC machinery and welding stations",
      "In-house blasting and painting booth",
      "ISO-certified quality systems",
      "Specialized fabrication for power and industrial sectors",
    ],
    facilityImg: [
      "https://media.arcengltd.com/facility-images/Hamriyah_Facility_04.webp",
      "https://media.arcengltd.com/facility-images/Hamriyah_Facility_07.webp",
      "https://media.arcengltd.com/facility-images/Hamriyah_Facility_05.webp",
      "https://media.arcengltd.com/facility-images/Hamriyah_Facility_03.webp",
      "https://media.arcengltd.com/facility-images/Hamriyah_Facility_06.webp",
      "https://media.arcengltd.com/facility-images/Hamriyah_Facility_01.webp",
      "https://media.arcengltd.com/facility-images/Hamriyah_Facility_02.webp",
    ],
    capabilityImg: [
      {
        img: "https://media.arcengltd.com/facility-images/Hamriyah_Facility_Capability_01.webp",
        title: "Shearing Machine",
        desc: "High-precision shearing machine for accurate cutting of industrial-grade steel sheets.",
      },
      {
        img: "https://media.arcengltd.com/facility-images/Hamriyah_Facility_Capability_02.webp",
        title: "CNC Plasma Cutter",
        desc: "CNC-controlled plasma cutting machine for complex shapes and heavy-duty cuts.",
      },
      {
        img: "https://media.arcengltd.com/facility-images/Hamriyah_Facility_Capability_03.webp",
        title: "Bending Machine",
        desc: "Automated bending machine for precision-formed metal structures.",
      },
    ],
  },
  {
    id: "sajja",
    title: "UAE - Sajja Facility",
    desc: "Modern production center featuring cutting-edge technology for industrial solutions and high-quality manufacturing processes.",
    location: "Sajja Industrial Area, Sharjah",
    totalArea: "85,000 sq.ft",
    productionCapacity: "Up to 1,200 tons annually",
    highlights: [
      "Dedicated assembly and testing area",
      "Heavy-duty fabrication bays",
      "High-efficiency workflow layout",
      "Advanced QA/QC inspection tools",
    ],
    facilityImg: [
      "https://media.arcengltd.com/facility-images/Sajja_Facility_03.webp",
      "https://media.arcengltd.com/facility-images/Sajja_Facility_04.webp",
      "https://media.arcengltd.com/facility-images/Sajja_Facility_02.webp",
      "https://media.arcengltd.com/facility-images/Sajja_Facility_01.webp",
    ],
    capabilityImg: [
      {
        img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_04.webp",
        title: "Heavy-Duty Welding Stations",
        desc: "Multiple welding lines equipped for large-scale industrial fabrication.",
      },
      {
        img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_02.webp",
        title: "CNC Machining Zone",
        desc: "Advanced CNC units for machining with high repeatability and precision.",
      },
      {
        img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_03.webp",
        title: "Assembly & Integration Area",
        desc: "Designated space for assembling complete power systems and industrial units.",
      },
      {
        img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_01.webp",
        title: "QA/QC Inspection Tools",
        desc: "Fully equipped testing and inspection area ensuring reliability and compliance.",
      },
    ],
  },
];
